// import lamejs from 'lamejs';

// export const convertToMp3 = async (blob) => {
//     console.log(blob, "convertToMp3");
//     try {
//         if (typeof lamejs.MPEGMode === 'undefined') {
//             lamejs.MPEGMode = { STEREO: 0, JOINT_STEREO: 1, DUAL_CHANNEL: 2, MONO: 3 };
//         }
//         console.log('Blob Type:', blob.type);

//         const audioContext = new AudioContext();
//         const arrayBuffer = await blob.arrayBuffer();
//         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

//         console.log('AudioBuffer SampleRate:', audioBuffer.sampleRate);
//         console.log('AudioBuffer Channels:', audioBuffer.numberOfChannels);
//         const channels = audioBuffer.numberOfChannels;
//         const sampleRate = audioBuffer.sampleRate;

//         const mp3Encoder = new lamejs.Mp3Encoder(channels, sampleRate, 128);
//         const mp3Data = [];
//         const blockSize = 1152;

//         for (let channel = 0; channel < channels; channel++) {
//             const samples = new Int16Array(audioBuffer.length);
//             const channelData = audioBuffer.getChannelData(channel);

//             for (let i = 0; i < audioBuffer.length; i++) {
//                 samples[i] = Math.max(-32768, Math.min(32767, Math.floor(channelData[i] * 32768)));
//             }

//             for (let i = 0; i < samples.length; i += blockSize) {
//                 const sampleChunk = samples.subarray(i, i + blockSize);
//                 const mp3buf = mp3Encoder.encodeBuffer(sampleChunk);
//                 if (mp3buf.length > 0) {
//                     mp3Data.push(mp3buf);
//                 }
//             }
//         }

//         const end = mp3Encoder.flush();
//         if (end.length > 0) {
//             mp3Data.push(end);
//         }

//         return new Blob(mp3Data, { type: 'audio/mp3' });
//     } catch (error) {
//         console.error('MP3 conversion error:', error);
//         throw new Error('Failed to convert audio to MP3 format');
//     }
// };




import lamejs from 'lamejs';

// MP3 conversion function remains the same as your original implementation
export const convertToMp3 = async (blob) => {
    // console.log(blob, "convertToMp3");
    try {
        if (typeof lamejs.MPEGMode === 'undefined') {
            lamejs.MPEGMode = { STEREO: 0, JOINT_STEREO: 1, DUAL_CHANNEL: 2, MONO: 3 };
        }
        // console.log('Blob Type:', blob.type);

        const audioContext = new AudioContext();
        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        // console.log('AudioBuffer SampleRate:', audioBuffer.sampleRate);
        // console.log('AudioBuffer Channels:', audioBuffer.numberOfChannels);
        const channels = audioBuffer.numberOfChannels;
        const sampleRate = audioBuffer.sampleRate;

        const mp3Encoder = new lamejs.Mp3Encoder(channels, sampleRate, 128);
        const mp3Data = [];
        const blockSize = 1152;

        for (let channel = 0; channel < channels; channel++) {
            const samples = new Int16Array(audioBuffer.length);
            const channelData = audioBuffer.getChannelData(channel);

            for (let i = 0; i < audioBuffer.length; i++) {
                samples[i] = Math.max(-32768, Math.min(32767, Math.floor(channelData[i] * 32768)));
            }

            for (let i = 0; i < samples.length; i += blockSize) {
                const sampleChunk = samples.subarray(i, i + blockSize);
                const mp3buf = mp3Encoder.encodeBuffer(sampleChunk);
                if (mp3buf.length > 0) {
                    mp3Data.push(mp3buf);
                }
            }
        }

        const end = mp3Encoder.flush();
        if (end.length > 0) {
            mp3Data.push(end);
        }

        return new Blob(mp3Data, { type: 'audio/mp3' });
    } catch (error) {
        console.error('MP3 conversion error:', error);
        throw new Error('Failed to convert audio to MP3 format');
    }
};

// Convert to WAV
export const convertToWav = async (blob) => {
    try {
        const audioContext = new AudioContext();
        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        const wavBuffer = audioBufferToWav(audioBuffer);
        return new Blob([wavBuffer], { type: 'audio/wav' });
    } catch (error) {
        console.error('WAV conversion error:', error);
        throw new Error('Failed to convert audio to WAV format');
    }
};

// Convert to CAF (Core Audio Format)
export const convertToCaf = async (blob) => {
    try {
        const audioContext = new AudioContext();
        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        // For CAF, we'll use a simple workaround by creating a WAV buffer
        // Note: This is not a true CAF conversion but a WAV approximation
        const cafBuffer = audioBufferToWav(audioBuffer);
        return new Blob([cafBuffer], { type: 'audio/x-caf' });
    } catch (error) {
        console.error('CAF conversion error:', error);
        throw new Error('Failed to convert audio to CAF format');
    }
};

// Convert to M4A
export const convertToM4a = async (blob) => {
    try {
        const audioContext = new AudioContext();
        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

        // Offline audio context for re-rendering at 44100 Hz
        const offlineContext = new OfflineAudioContext(
            audioBuffer.numberOfChannels,
            audioBuffer.length,
            44100
        );

        const source = offlineContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(offlineContext.destination);
        source.start();

        const renderedBuffer = await offlineContext.startRendering();

        // Convert rendered buffer to M4A Blob
        const wavBuffer = audioBufferToWav(renderedBuffer);
        return new Blob([wavBuffer], { type: 'audio/m4a' });
    } catch (error) {
        console.error('M4A conversion error:', error);
        throw new Error('Failed to convert to M4A.');
    }
};


// Utility function to convert AudioBuffer to WAV
function audioBufferToWav(audioBuffer) {
    const numOfChan = audioBuffer.numberOfChannels;
    const length = audioBuffer.length * numOfChan * 2 + 44;
    const buffer = new ArrayBuffer(length);
    const view = new DataView(buffer);
    const channels = [];
    let sample;
    let offset = 0;
    let pos = 0;

    // write WAVE header
    setUint32(0x46464952);                         // "RIFF"
    setUint32(length - 8);                         // file length
    setUint32(0x45564157);                         // "WAVE"

    setUint32(0x20746d66);                         // "fmt " chunk
    setUint32(16);                                 // length = 16
    setUint16(1);                                  // PCM (uncompressed)
    setUint16(numOfChan);
    setUint32(audioBuffer.sampleRate);
    setUint32(audioBuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
    setUint16(numOfChan * 2);                      // block-align
    setUint16(16);                                 // 16-bit (hardcoded in this demo)

    setUint32(0x61746164);                         // "data" - chunk
    setUint32(length - pos - 4);                   // chunk length

    // write interleaved data
    for (let i = 0; i < audioBuffer.numberOfChannels; i++)
        channels.push(audioBuffer.getChannelData(i));

    while (pos < length) {
        for (let i = 0; i < numOfChan; i++) {
            sample = Math.max(-1, Math.min(1, channels[i][offset]));
            sample = (0.5 + sample < 0 ? sample * 32768 : sample * 32767) | 0;
            view.setInt16(pos, sample, true);
            pos += 2;
        }
        offset++;
    }

    // helper functions
    function setUint16(data) {
        view.setUint16(pos, data, true);
        pos += 2;
    }

    function setUint32(data) {
        view.setUint32(pos, data, true);
        pos += 4;
    }

    return buffer;
}

